// Deal with BMI displays when .displayBMI is clicked or changed
ht.declare('.displayBMI', function () {
  var options = $(this).data('displayBmiOpts');
  $(this).on('click change', function () {
    ht.displayBMI(options);
  });
});
